import { View } from 'react-native'
import { StyleSheet } from 'react-native-unistyles'

import UniButton from '@/components/unistyles/UniButton'
import UniText from '@/components/unistyles/UniText'
import UserService from '@/services/userService'

const DeactivatedBanner = () => {
  const { user, currentOrganization } = UserService.useUser()

  const reactivateMutation = UserService.useReactivateMutation()

  if (!user || !user.deactivatedAt) return

  const reactivate = () => {
    if (!user || !currentOrganization?.id) {
      return
    }

    reactivateMutation.mutate({
      id: user.id,
      organizationId: currentOrganization.id,
    })
  }

  return (
    <View style={styles.banner} testID="deactivated-banner">
      <View style={styles.bannerContent}>
        <UniText>{user.firstName}'s account has been deactivated.</UniText>
        <UniButton
          disabled={reactivateMutation.isPending}
          labelStyle={styles.bannerButton}
          loading={reactivateMutation.isPending}
          onPress={reactivate}
        >
          Reactivate
        </UniButton>
      </View>
    </View>
  )
}

const styles = StyleSheet.create((theme) => ({
  banner: {
    backgroundColor: theme.colors.errorContainer,
    borderColor: theme.colors.error,
    borderRadius: theme.tokens.containerBorderRadius,
    borderWidth: 1,
    paddingBottom: theme.tokens.spacing[3],
    paddingLeft: theme.tokens.spacing[4],
    paddingRight: theme.tokens.spacing[4],
    paddingTop: theme.tokens.spacing[3],
  },
  bannerButton: {
    color: theme.colors.onSurface,
  },
  bannerContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: theme.tokens.spacing[3],
    paddingRight: theme.tokens.spacing[3],
  },
}))

export default DeactivatedBanner
